var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.images.length
    ? _c(
        "div",
        { staticClass: "review-card-images d-flex flex-wrap" },
        _vm._l(_setup.images, function (image, index) {
          return _c(
            "button",
            {
              key: image.id ?? image.src,
              staticClass: "review-card-images__btn",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.$emit("open", index)
                },
              },
            },
            [
              _c("img", {
                staticClass: "review-card-images__image",
                attrs: { src: image.previewSrc, alt: "", loading: "lazy" },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass:
                  "review-card-images__hover ui-icon-search bg-gray-0--text",
              }),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }